import React from 'react';
import './styles.css';
import CardHelper from "../../helpers";

function CardMorePopular(props) {
  return (
    <div className={'card card-popular'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {props.cover !== '' &&
          <div
            className='card-cover'
            style={{ backgroundImage: `url(${props.portrait})` }}
          />
          }
          {CardHelper.createBadge(props.badges)}
        </div>
      </div>
    </div>
  );
}

export default CardMorePopular;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardMorePopular/index.js